<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <vs-button id="addButton" color="warning" href="/designer/new" type="filled">Create</vs-button>

    <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">

      <div class="notification-top text-center p-5 bg-primary text-white">
        <p class="opacity-75">Add a New Component</p>
      </div>

        <ul class="bordered-items">
          <li v-for="(ntf, index) in listItems" @click="handleClik(index)" :key="ntf.index" class="flex justify-between px-4 py-4 notification cursor-pointer">
            <div class="flex items-start">
              <div class="mx-2">
                <h5 class="font-medium block notification-title" :class="[`text-${ntf.category}`]">{{ ntf.title }}</h5>
                <small>{{ ntf.msg }}</small>
              </div>
            </div>
          </li>
        </ul>

    </vs-dropdown-menu>
    <vs-popup
      class="editPopup"
      v-if="editPopup"
      :active.sync="editPopup"
      title="Add Project"
    >
      <vs-row>
        <vs-col>
          <vs-input label-placeholder="Name" v-model="projectName" data-lpignore="true"/>
          <vs-input label-placeholder="Description" v-model="projectDescription" data-lpignore="true"/>
          <vs-button id="saveProject" class="flex-none" @click="saveProject" color="primary" type="filled" size="medium">Save</vs-button>
        </vs-col>
      </vs-row>
    </vs-popup>
    
    <vs-popup
      class="agentPopup"
      v-if="agentPopup"
      :active.sync="agentPopup"
      title="Add an Agent"
    >
      <vs-row>
        <vs-col>
          <vs-input label-placeholder="Name" v-model="agentName" data-lpignore="true"/>
          <vs-input label-placeholder="Description" v-model="agentDescription" data-lpignore="true"/>
          <vs-button id="saveAgent" class="flex-none" @click="saveAgent" color="primary" type="filled" size="medium">Add</vs-button>
        </vs-col>
      </vs-row>
      
    </vs-popup>
    <vs-popup
      class="agentInfoPopup"
      v-if="agentInfoPopup"
      :active.sync="agentInfoPopup"
      title="One-time Agent Information"
    >
      <vs-row>
        <vs-col id="agentInfo">
          <br/>
          <b>*Securely store the Token, it will not be visible again*</b>
          <br/>
          <br/>
          <h5>Token: </h5>
          <span>{{agent_token}}</span>
          <br/>
          <h5 style="margin-top: 35px">Linux Install Command: </h5>
          <pre>export TOKEN=&lt;token&gt;<br/>curl -s https://get.clikr.io | sudo bash</pre>

        </vs-col>
      </vs-row>
    </vs-popup>
  </vs-dropdown>
</template>

<script>
export default {
  components: {

  },
  data () {
    return {
      editPopup: false,
      agentPopup: false,
      projectName: '',
      projectDescription: '',
      agentName: '',
      agentDescription: '',
      agentInfoPopup: false,
      agent_token: 'test12345',
      listItems: [
        {
          title    : 'Project',
          msg      : 'Create a new project',
          category : 'primary',
          handle () {
            this.editPopup = true
          }
        },
        {
          title    : 'Clik',
          msg      : 'Add a new clik workflow to your project',
          category : 'primary',
          handle () {
            const $this = this
            //determine if we are on a project page
            if ($this.$router.currentRoute.name === 'project') {
              $this.$router.push({ name: 'clik-designer', params: { id: $this.$router.currentRoute.params.id, clik_id: 'new' } })
            } else {
              //if not, find default project and use that
              $this.$http
                .get(`${process.env.VUE_APP_API_ENDPOINT}/project`, {
                  headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
                })
                .then(response => {
                  for (let i = 0; i < response.data.length; i++) {
                    if (response.data[i].deletable === 0) {
                      $this.$router.push({ name: 'clik-designer', params: { id: response.data[i].guid, clik_id: 'new' } })
                    }
                  }
                })
            }
          }
        },
        {
          title    : 'Agent',
          msg      : 'Add a new agent',
          category : 'primary',
          handle () {
            this.agentPopup = true
          }
        }
      ]
    }
  },
  watch: {
    agentInfoPopup (val) {
      if (val === false) {
        this.agentPopup = false
      }
    },
    editPopup (val) {
      if (val === false) {
        this.projectName = ''
        this.projectDescription = ''
      }
    },
    agentPopup (val) {
      if (val === false) {
        this.agentName = ''
        this.agentDescription = ''
      }
    }
  },
  methods: {
    handleClik (index) {
      this.listItems[index]['handle'].call(this)
    },
    saveAgent () {
      const $this = this
      const p_id = this.$router.currentRoute.params.p_id || this.$router.currentRoute.params.id
      $this.$http
        .post(`${process.env.VUE_APP_API_ENDPOINT}/agent`, {name: $this.agentName, description: $this.agentDescription, project_id: p_id}, {
          headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
        })
        .then((response) => {
          $this.$vs.notify({
            color: 'success',
            title: 'Agent Added'
          })
          $this.agent_token = `${response.data.guid}:${response.data.secret}`
          $this.agentInfoPopup = true

          
          $this.$root.$emit('updateAgents')
        }).catch((err) => {
          $this.$vs.notify({
            color: 'danger',
            title: err.response.data.message
          })
        })

    },
    saveProject () {
      const $this = this
      $this.$http
        .post(`${process.env.VUE_APP_API_ENDPOINT}/project`, {name: $this.projectName, description: $this.projectDescription}, {
          headers: { 'Authorization': `Bearer ${localStorage.jwt}` }
        })
        .then(() => {
          $this.$vs.notify({
            color: 'success',
            title: 'Project created'
          })
          $this.editPopup = false
          $this.$emit('updateNavbarProjects')
        }).catch((err) => {
          $this.$vs.notify({
            color: 'danger',
            title: err.response.data.message
          })
        })
    }
  }
}
</script>
<style lang="scss">
#saveProject, #saveAgent {
  float: right;
  margin-top: 15px;
}
.agentInfoPopup {
  z-index: 999999999;
}
#agentInfo {
  text-align: center;

  pre {
    color: silver;
    background: black;
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 5px;
  }
}
</style>
